"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Transformation({
  videoUrl
}: {
  videoUrl?: string;
}) {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const insights = [{
    date: "Featured Articles • Medical Technology ",
    category: "Innovation",
    title: "The Future of AI in Healthcare"
  }, {
    date: "Global Markets ",
    category: "Market Trends",
    title: "Medical Device Market Outlook"
  }, {
    date: "Industry Insights ",
    category: "Regulatory",
    title: "Healthcare Innovation Updates\n"
  }];
  return <section data-section-id="4535" id="transformsupplychaincta" className="bg-background text-foreground relative w-full overflow-hidden">
      {videoUrl ? <div className="absolute inset-0 w-full h-full overflow-hidden">
          {videoUrl.includes("youtube.com") || videoUrl.includes("vimeo.com") ? <iframe src={videoUrl} className="w-full h-full object-cover" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen /> : <video src={videoUrl} autoPlay loop muted playsInline className="w-full h-full object-cover" />}
        </div> : <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727079/img/medical_innovation_global.webp)]" />}

      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(222, 30%, 18%, 0.9) 0%, hsla(174, 65%, 20%, 0.8) 50%, hsla(222, 30%, 18%, 0.85) 100%)"
    }} />

      <div className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[1000px] flex-col items-center px-6 py-24 text-center md:py-32 lg:py-40">
        <h2 ref={headingRef} className={`font-default font-bold text-white text-5xl leading-heading tracking-normal transition-smooth duration-300 ease-in-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}><span className="!text-3xl">KNOWLEDGE CENTER <br />Healthcare Insights &amp; Market Intelligence</span></h2>

        <p ref={bodyRef} className="max-w-[700px] leading-normal text-muted-foreground transition-smooth duration-300 ease-in-out opacity-100 translate-y-0 !text-xl ![margin:32px_0px_0px_0px] !w-[800px]" style={{
        fontFamily: "var(--font-default)"
      }}>At MS Biotechnology, we believe informed decisions are built on reliable insights and a clear understanding of the evolving healthcare landscape. We continuously follow developments in medical technology, healthcare innovation, global market trends, and industry perspectives to help our partners identify emerging opportunities.

By sharing practical insights and market intelligence, we support manufacturers, distributors, healthcare professionals, and business partners in making informed decisions and building successful international collaborations.</p>

        <div className="mt-16 grid w-full grid-cols-1 gap-6 md:grid-cols-3">
          {insights.map((item, i) => <div key={i} className="flex flex-col rounded-2xl bg-white/10 p-6 text-left backdrop-blur-sm transition-smooth duration-300 hover:bg-white/15">
              
              <h3 className="mt-3 text-xl font-default font-semibold text-white">{item.title}</h3>
              <div className="mt-auto pt-6">
                <Button asChild variant="outline" className="w-full border-white/20 text-white transition-smooth duration-300 hover:bg-white hover:text-primary">
                  <Link to="/InsightsPage">Learn More</Link>
                </Button>
              </div>
            </div>)}
        </div>

        <div ref={ctaRef} className={`mt-14 flex flex-col items-center gap-6 transition-smooth duration-300 ease-in-out sm:flex-row sm:gap-8 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="group h-auto rounded-lg bg-primary px-8 py-4 text-base font-medium text-white shadow-md transition-smooth duration-300 hover:bg-primary/90 hover:shadow-lg hover:-translate-y-0.5">
            <Link to="/TechnologyPortfolioPage">Explore Our Portfolio
              <ArrowRight className="ml-1 size-4 transition-smooth duration-300 group-hover:translate-x-1" /></Link>
          </Button>
        </div>
      </div>
    </section>;
}